export default __webpack_public_path__ + "static/media/bj3.cdbb13c8.png";